<template>
  <div class="complaintTypeConfig">
    <module-title title="添加社区">
      <div class="right">
        <el-button type="primary" size="medium" icon="el-icon-arrow-left" @click="$emit('back')">
          返回上一页
        </el-button>
      </div>
    </module-title>
    <div class="addcommunity">
      <el-form
        ref="handleForm"
        :model="handleForm"
        label-position="right"
        label-width="100px"
      >
        <el-form-item label="所属区域：" prop="areaCode" :rules="handleItemRules.areaCode">
          <el-cascader
            v-model="handleForm.areaCode"
            :options="areaData"
            :props="areaProps"
            class="handle-form-input"
            clearable
            placeholder="选择省/市/区县"
            @change="areaChange"
          />
        </el-form-item>
        <div v-for="(item,index) of handleForm.streetList" :key="item.id">
          <!-- {{handleItemRules.streetName}} :rules="{ required: true, trigger: 'blur', message: '入口地址不能为空' }" -->
          <el-form-item label="街道名称：" :prop="`streetList.${index}.streetName`" :rules="handleItemRules.streetName">
            <el-select
              id="getStreetList"
              v-model="item.streetName"
              maxlength="20"
              name="streetName"
              size="medium"
              class="handle-form-input"
              clearable
              filterable
              allow-create
              default-first-option
            >
              <el-option
                v-for="v of streetsData"
                :key="v.id"
                :label="v.streetName"
                :value="v.id"
              />
            </el-select>
            <span class="iconn-add-bnt" @click="addcommunityList('street',{index})"> <i class="el-icon-circle-plus" /></span>
            <span v-if="index>0" class="iconn-add-bnt" @click="delcommunityList('street',{index})"> <i class="el-icon-delete-solid" /></span>
          </el-form-item>
          <div v-for="(subitem,subindex) of item.dtos" :key="subitem.id" class="subItem">
            <el-form-item label="社区名称：" :prop="`streetList.${index}.dtos.${subindex}.communityName`" :rules="handleItemRules.communityName">
              <el-input
                v-model="subitem.communityName"
                type="text"
                name="title"
                placeholder="请输入社区名称"
                class="handle-form-input"
                maxlength="20"
                show-word-limit
              />
              <span class="iconn-add-bnt" @click="addcommunityList('community',{index,subindex})"> <i class="el-icon-circle-plus" /></span>
              <span v-if="index>0||subindex>0" class="iconn-add-bnt" @click="delcommunityList('community',{index,subindex})"> <i class="el-icon-delete-solid" /></span>
            </el-form-item>
            <div v-for="(littenitem,littenindex) of subitem.community" :key="littenitem.id" class="subItem">
              <el-form-item label="社区地址：" prop="communitySite">
                <el-input
                  v-model="littenitem.communitySite"
                  type="text"
                  name="title"
                  placeholder="请输入社区地址"
                  class="handle-form-input1"
                  maxlength="20"
                  show-word-limit
                />
                <span class="iconn-add-bnt" @click="addcommunityList('site',{index,subindex,littenindex})"> <i class="el-icon-circle-plus" /></span>
                <span v-if="index>0||subindex>0||littenindex>0" class="iconn-add-bnt" @click="delcommunityList('site',{index,subindex,littenindex})"> <i class="el-icon-delete-solid" /></span>
              </el-form-item>
              <el-form-item label="所属学校：" :rules="handleItemRules.treeNode" prop="treeNode">
                <el-input
                  v-model="handleForm.treeNodeName"
                  size="medium"
                  class="handle-form-input"
                  suffix-icon="el-icon-search"
                  placeholder="请选择所属学校"
                  clearable
                />
              </el-form-item>
              <div style="margin-left: 100px;">
                <my-tree
                  ref="myTree"
                  only-school
                  :filter-text="handleForm.treeNodeName"
                  @treeNodeClick="treeNodeClick"
                />
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <div class="dialog-footer">
      <el-button size="medium" @click="handleSearchReset">
        取消
      </el-button>
      <el-button type="primary" size="medium" @click="handleAddcommunity">
        保存
      </el-button>
    </div>
  </div>
</template>
<script>
import {
  batch_add,
  getStreets
} from '@/api/systemMaintenance/devicManage/cascaderConfig';
import { mapGetters } from 'vuex';
import MyTree from '@/components/MyTreeFormItem';
export default {
  name: 'CascaderConfigAdd',
  components: { MyTree },
  data() {
    return {
      areaProps: {
        value: 'code',
        label: 'name',
        children: 'children'
      },
      streetsData: [],
      handleForm: {
        areaCode: '',
        provinceId: '',
        cityId: '',
        areaId: '',
        createUserCode: '',
        streetList: [{
          streetName: '',
          dtos: [{
            communityName: '',
            community: [{
              communitySite: ''
            }]
          }]
        }],
        dtos: [],
        treeNode: '',
        treeNodeName: ''
      },
      treeNode: '',
      handleItemRules: {
        areaCode: { required: true, trigger: 'blur', message: '所属区域不能为空' },
        streetName: { required: true, trigger: 'change', message: '街道名称不能为空' },
        communityName: { required: true, trigger: 'blur', message: '社区名称不能为空' },
        treeNode: { required: true, trigger: 'change', message: '请选择所属学校' }
      }
    };
  },
  computed: {
    ...mapGetters(['areaData', 'userInfo'])
  },
  mounted() {
    document.querySelector('#getStreetList').setAttribute('maxLength', 20);// 街道名称限制字数
    this.$store.dispatch('getNodes'); // 获取区域
  },
  methods: {
    // 树点击事件
    treeNodeClick(data) {
      this.handleForm.treeNodeName = data.name;
      this.handleForm.treeNode = data.code;
      this.treeNode = data;
    },
    // 删除
    delcommunityList(val, num) {
      switch (val) {
        case 'street':
          this.handleForm.streetList.splice(num.index, 1);
          break;
        case 'community':
          this.handleForm.streetList[num.index].dtos.splice(num.subindex, 1);
          break;
        case 'site':
          this.handleForm.streetList[num.index].dtos[num.subindex].community.splice(num.littenindex, 1);
          break;
      }
    },
    // 添加
    addcommunityList(val, num) {
      switch (val) {
        case 'street':
          this.handleForm.streetList.push({
            streetName: '',
            dtos: [{
              communityName: '',
              community: [{
                communitySite: ''
              }]
            }]
          });
          break;
        case 'community':
          this.handleForm.streetList[num.index].dtos.push({
            communityName: '',
            community: [{
              communitySite: ''
            }]
          });
          break;
        case 'site':
          this.handleForm.streetList[num.index].dtos[num.subindex].community.push({
            communitySite: ''
          });
          break;
      }
    },
    areaChange(val) {
      this.handleForm.provinceId = val[0] ? val[0] : '';
      this.handleForm.cityId = val[1] ? val[1] : '';
      this.handleForm.areaId = val[2] ? val[2] : '';
      this.fetchStreet();
    },
    fetchStreet() {
      var op = {
        provinceId: this.handleForm.provinceId,
        cityId: this.handleForm.cityId,
        areaId: this.handleForm.areaId
      };
      getStreets(op).then(res => {
        if (res.data && res.data.length > 0) {
          this.streetsData = res.data;
        } else {
          this.streetsData = [];
        }
      }).catch(err => {
        console.log(err);
        this.$message.warning('请求错误');
      });
    },
    handleSearchReset() {
      this.handleForm = {
        areaCode: '',
        provinceId: '',
        cityId: '',
        areaId: '',
        createUserCode: '',
        streetList: [{
          streetName: '',
          dtos: [{
            communityName: '',
            community: [{
              communitySite: ''
            }]
          }]
        }],
        dtos: []
      };
    },
    // 保存
    handleAddcommunity() {
      this.$refs['handleForm'].validate(valid => {
        if (valid) {
          if (!this.treeNode.code) {
            this.$message.error('所属学校为必选');
            return;
          }
          var op = [];
          this.handleForm.streetList.forEach(item => {
            var dtos = [];
            if (item.dtos.length > 0) {
              item.dtos.forEach(subitem => {
                var community = [];
                if (subitem.community.length > 0) {
                  subitem.community.forEach(littenitem => {
                    community.push(littenitem.communitySite);
                  });
                }
                dtos.push({
                  communityName: subitem.communityName,
                  communitySite: community.join(','),
                  createUserCode: this.userInfo.code
                });
              });
              op.push({
                provinceId: this.handleForm.provinceId,
                cityId: this.handleForm.cityId,
                areaId: this.handleForm.areaId,
                streetName: item.streetName,
                createUserCode: this.userInfo.code,
                dtos
              });
            }
          });
          batch_add(this.treeNode.code, op)
            .then(res => {
              this.$notify.success({
                title: 'Success',
                message: `添加社区成功`,
                showClose: false,
                duration: 2000
              });
              this.$emit('back');
            }).catch(err => {
              console.log(err);
            });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.addcommunity {
  padding-bottom: 20px;
  .handle-form-input {
    width: 80%;
  }
  .handle-form-input1{
    width: 50%;
  }
  .subItem{ margin-left: 40px; }
  .iconn-add-bnt{
    font-size: 22px;
    margin-left: 10px;
    line-height: 36px;
  }
}
.dialog-footer{text-align: center;margin-top: 20px;}
</style>
